import React, { useState } from "react";
import "./About.css"; // Assure-toi d'importer le fichier CSS

function About() {
  // État pour suivre l'image agrandie
  const [selectedImage, setSelectedImage] = useState(null);

  // Fonction pour ouvrir l'aperçu
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  // Fonction pour fermer l'aperçu
  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="about">
      {/* Première partie : titre, texte et photo */}
      <div className="about-top">
        {/* Partie gauche - Titre et texte */}
        <div className="about-text">
          <h1 className="about-title">À propos de moi</h1>
          <p>
            Je suis Joseph KOUAKOU Constant dit{" "}
            <span className="lebosseur">“LEBOSSEUR”</span>, Ingénieur
            informaticien chevronné avec plus de 10 ans d'expertise dans
            l'administration avancée des bases de données et le développement
            web et d'applications. J'ai une maîtrise complète des technologies
            de gestion de bases de données, y compris la conception,
            l'optimisation des performances et la sécurité. Expérimenté dans le
            développement d'applications web robustes, avec une forte expertise
            dans la création de solutions efficaces et évolutives, je suis
            capable de résoudre des problèmes complexes et de mettre en œuvre
            des solutions novatrices pour répondre aux besoins spécifiques des
            projets. Fort engagement envers l'excellence technique et la
            satisfaction du client.
          </p>
        </div>

        {/* Partie droite - Photo */}
        <div className="about-photo">
          <img
            src="/images/tof_bureau.jpg" // Remplace par ta vraie photo
            alt="Joseph KOUAKOU Constant"
            className="profile-photo"
          />
        </div>
      </div>

      {/* Deuxième partie : Galerie des projets */}
      <div className="about-bottom">
        <h2>Mes projets réalisés</h2>
        <div className="gallery">
          <div
            className="gallery-item tof1"
            onClick={() => handleImageClick("/images/portfolio.png")}
          >
            <img src="/images/portfolio.png" alt="Portfolio" />
            <p>Mon Portfolio</p>
          </div>

          <div
            className="gallery-item tof2"
            onClick={() => handleImageClick("/images/labo.jpg")}
          >
            <img src="/images/labo.jpg" alt="Logiciel de BIOLOGIE MEDICALE" />
            <p>Logiciel de BIOLOGIE MEDICALE</p>
          </div>
          <div
            className="gallery-item tof3"
            onClick={() => handleImageClick("/images/bureau.jpg")}
          >
            <img
              src="/images/bureau.jpg"
              alt="Logiciel de caisse de centre de santé"
            />
            <p>Logiciel de caisse de centre de santé</p>
          </div>
          <div
            className="gallery-item tof4"
            onClick={() => handleImageClick("/images/pharma.jpg")}
          >
            <img
              src="/images/pharma.jpg"
              alt="Logiciel de pharmacie de centre de santé"
            />
            <p>Logiciel de pharmacie de centre de santé</p>
          </div>
        </div>
      </div>

      {/* Modal pour l'aperçu de l'image */}
      {selectedImage && (
        <div className="image-modal" onClick={handleCloseModal}>
          <div className="modal-content">
            <img src={selectedImage} alt="Aperçu" className="modal-image" />
            <span className="close-modal" onClick={handleCloseModal}>
              &times;
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default About;
